(() => {
  'use strict';
  const config = JSON.parse(document.querySelector('#storefront-config')?.textContent || '{}');
  const root = config.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement?.lang || 'en', {style:'currency',currency:config.currency || 'USD',minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100);
  const page = document.querySelector('[data-cart-page]');
  const status = page?.querySelector('[data-cart-page-status]');
  let busy = false;
  const permanentlyDisabled = new WeakSet(page?.querySelectorAll('button:disabled,input:disabled') || []);
  const lock = value => { busy=value; page?.setAttribute('aria-busy',String(value)); page?.querySelectorAll('button,input').forEach(el => el.disabled=value||permanentlyDisabled.has(el)); };
  async function api(path,payload) {
    const response=await fetch(root+path,payload===undefined?{cache:'no-store',headers:{Accept:'application/json'}}:{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
    const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||'Please try again.');return data;
  }
  async function quantity(key,value) {
    if(busy||!Number.isInteger(value)||value<0||value>99)return;
    lock(true);status.textContent='Updating your cart…';
    try{await api('cart/change.js',{id:key,quantity:value});location.reload();}
    catch(error){lock(false);status.textContent=error.message;}
  }
  page?.querySelectorAll('[data-page-quantity]').forEach(button=>button.addEventListener('click',()=>quantity(button.dataset.key,Number(button.dataset.pageQuantity))));
  page?.querySelectorAll('[data-page-quantity-input]').forEach(input=>input.addEventListener('change',()=>{if(input.reportValidity())quantity(input.dataset.key,Number(input.value));}));
  page?.querySelectorAll('[data-page-remove]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();quantity(link.dataset.key,0);}));
  page?.querySelectorAll('[data-upgrade-cart]').forEach(button=>button.addEventListener('click',async()=>{
    if(busy)return;lock(true);status.textContent='Updating your subscription…';
    const id=Number(button.dataset.variant),plan=Number(button.dataset.plan);
    const planId=item=>Number(item.selling_plan_allocation?.selling_plan.id)||0;
    const properties=item=>JSON.stringify(Object.entries(item.properties||{}).sort(([a],[b])=>a.localeCompare(b)));
    const matches=(a,b)=>Number(a.variant_id)===Number(b.variant_id)&&planId(a)===planId(b)&&properties(a)===properties(b);
    const total=(cart,item)=>cart.items.filter(line=>matches(line,item)).reduce((sum,line)=>sum+line.quantity,0);
    let source,target,beforeSource=0,beforeTarget=0,count=0,attempted=false;
    const finished=cart=>total(cart,source)===beforeSource-count&&total(cart,target)===beforeTarget+count;
    try{
      const before=await api('cart.js');
      source=before.items.find(item=>item.key===button.dataset.oldKey);
      if(!source||Number(source.variant_id)!==Number(button.dataset.sourceVariant)||Number(source.product_id)!==Number(button.dataset.product))throw new Error('Your bag has changed. Refresh it before upgrading.');
      count=source.quantity;
      if(!Number.isSafeInteger(id)||!Number.isSafeInteger(plan)||id<=0||plan<=0||id===Number(source.variant_id)||!planId(source)||!Number.isInteger(count)||count<1||count>99)throw new Error('This subscription upgrade is unavailable. Refresh your bag.');
      const targetProperties=window.NutrafolPricing.offerProperties(source.properties||{},Number(button.dataset.targetOriginal),Number(button.dataset.targetPrice),Number(button.dataset.targetMonths),money);
      target={variant_id:id,selling_plan_allocation:{selling_plan:{id:plan}},properties:targetProperties};
      beforeSource=total(before,source);beforeTarget=total(before,target);
      if(beforeTarget+count>99)throw new Error('This upgrade would exceed the maximum quantity of 99.');
      attempted=true;
      await api('cart/add.js',{items:[{id,quantity:count,selling_plan:plan,properties:targetProperties}]});
      // Adding an item can change Shopify line keys when discounts recalculate.
      // Resolve the original line again and confirm the full replacement exists.
      const added=await api('cart.js'),sources=added.items.filter(item=>matches(item,source));
      const current=sources.find(item=>item.key===source.key)||(sources.length===1?sources[0]:null);
      if(!current||current.quantity!==count||total(added,source)!==beforeSource||total(added,target)!==beforeTarget+count)throw new Error('Your bag changed or the full upgrade is unavailable. Please try again.');
      const changed=await api('cart/change.js',{id:current.key,quantity:0});
      if(!finished(changed))throw new Error('We could not confirm the subscription replacement.');
      location.reload();
    }catch(error){
      let confirmed=!attempted;
      if(attempted){
        try{
          const current=await api('cart.js');
          // A request can complete on Shopify even if its response is lost.
          if(finished(current)){location.reload();return;}
          const targetCount=total(current,target);
          if(total(current,source)===beforeSource&&targetCount>=beforeTarget&&targetCount<=beforeTarget+count){
            let restored=current;
            if(targetCount>beforeTarget){
              let remaining=beforeTarget;const updates={};
              current.items.filter(item=>matches(item,target)).forEach(item=>{const keep=Math.min(item.quantity,remaining);updates[item.key]=keep;remaining-=keep;});
              restored=await api('cart/update.js',{updates});
            }
            confirmed=total(restored,source)===beforeSource&&total(restored,target)===beforeTarget;
          }
        }catch{confirmed=false;}
      }
      lock(false);
      status.textContent=confirmed?error.message:'We could not confirm your subscription update. Refresh your bag before trying again or checking out.';
      if(!confirmed){permanentlyDisabled.add(button);button.disabled=true;const checkout=page.querySelector('[name=checkout]');if(checkout){permanentlyDisabled.add(checkout);checkout.disabled=true;}}
    }
  }));
  // Refresh checkout messaging from Shopify's actual cart prices, including bags
  // created before the offer changed. This never changes prices or selling plans.
  const cartForm=document.querySelector('#cart-page-form');let checkoutPrepared=false;
  cartForm?.addEventListener('submit',async event=>{
    if(event.submitter?.name!=='checkout'||checkoutPrepared)return;
    event.preventDefault();if(busy)return;lock(true);status.textContent='Preparing secure checkout…';
    try{
      let cart=await api('cart.js'),remaining=cart.items.length+1;
      while(remaining-->0){
        const next=cart.items.map(item=>{
          const original=item.selling_plan_allocation?.compare_at_price??item.original_price;
          const total=item.final_line_price/item.quantity,months=Number((item.variant_title||'').split('-')[0]);
          if(!Number.isFinite(original)||!Number.isFinite(total)||!months)return null;
          const properties=window.NutrafolPricing.offerProperties(item.properties||{},original,total,months,money);
          return JSON.stringify(properties)===JSON.stringify(item.properties||{})?null:{item,properties};
        }).find(Boolean);
        if(!next)break;
        cart=await api('cart/change.js',{id:next.item.key,quantity:next.item.quantity,properties:next.properties});
      }
    }catch{/* Checkout still uses Shopify's authoritative prices if optional copy could not refresh. */}
    checkoutPrepared=true;lock(false);cartForm.requestSubmit(event.submitter);
  });
  document.querySelector('[data-discount-form]')?.addEventListener('submit',async event=>{
    event.preventDefault();if(busy)return;
    const form=event.currentTarget;if(!form.reportValidity())return;
    const code=form.elements.discount.value.trim();if(!code)return;
    const message=document.querySelector('[data-discount-status]');lock(true);message.textContent='Checking discount…';
    try{
      const cart=await api('cart/update.js',{discount:code});
      const applied=cart.discount_codes?.some(discount=>discount.code.toLowerCase()===code.toLowerCase()&&discount.applicable);
      if(applied){location.reload();return;}
      message.textContent='This code is not available for the items in your cart.';
    }catch(error){message.textContent=error.message;}
    finally{lock(false);}
  });
  document.querySelector('[data-account-login]')?.addEventListener('submit',event=>{
    event.preventDefault();const form=event.currentTarget,input=form.elements.login_hint,value=input.value.trim();
    const email=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),phone=/^\+?[\d\s().-]{7,24}$/.test(value)&&value.replace(/\D/g,'').length>=7;
    input.setCustomValidity(email||phone?'':'Enter a valid email address or phone number.');if(!form.reportValidity())return;
    // Shopify owns verification and credentials. Only the documented login
    // hint is passed to its native customer-authentication route.
    const login=new URL(form.dataset.loginUrl,location.origin);
    if(email)login.searchParams.set('login_hint',value);
    location.assign(login.href);
  });
  document.querySelector('[data-account-login] input[name=login_hint]')?.addEventListener('input',event=>event.currentTarget.setCustomValidity(''));
})();
